import { Typography } from "@/components/ui/typography";
import { useTranslation } from "react-i18next";

export const NoCampaigns = () => {
  const { t } = useTranslation();
  return (
    <section className="h-64 w-full p-4">
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 rounded-lg border border-border/40 bg-secondary/40">
        <Typography tag="h4" className="text-muted-foreground/80">
          {t("general.noCampaignsTitle", "Nothing to show yet")}
        </Typography>
        <Typography tag="p" className="text-center text-muted-foreground/80">
          {t(
            "general.noCampaignsBody",
            "There is nothing available at the moment. Please check back later."
          )}
        </Typography>
      </div>
    </section>
  );
};

export const NoActiveCampaigns = () => {
  const { t } = useTranslation();
  return (
    <section className="h-64 w-full p-4">
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 rounded-lg border border-border/40 bg-secondary/40">
        <Typography tag="h4" className="text-muted-foreground/80">
          {t("general.noActiveCampaignsTitle", "Nothing active right now")}
        </Typography>
        <Typography tag="p" className="text-center text-muted-foreground/80">
          {t(
            "general.noActiveCampaignsBody",
            "There is nothing active at the moment. Please check back later."
          )}
        </Typography>
      </div>
    </section>
  );
};

export const LoggedOutState = () => {
  const { t } = useTranslation();
  return (
    <section className="h-64 w-full p-4">
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 rounded-lg border border-border/40 bg-secondary/40">
        <Typography tag="h4" className="text-muted-foreground/80">
          {t("general.loggedOutTitle")}
        </Typography>
        <Typography tag="p" className="text-center text-muted-foreground/80">
          {t("general.loggedOutBody")}
        </Typography>
      </div>
    </section>
  );
};

export const NoFinishedCampaigns = () => {
  const { t } = useTranslation();
  return (
    <section className="h-64 w-full p-4">
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 rounded-lg border border-border/40 bg-secondary/40">
        <Typography tag="h4" className="text-center text-muted-foreground/80">
          {t("general.nothingHereYet")}
        </Typography>
      </div>
    </section>
  );
};
